export const StrategySelectors = {
  Shared: 'sharedStrategies',
  My: 'myStrategies',
  Subscribed: 'subscribedStrategies',
};

export const SubscriptionTypes = {
  Alert: 'Alert',
  AutoTrade: 'AutoTrade',
};

export const AlertTypes = {
  //Sms: 'Sms',
  Email: 'Email',
  //SmsAndEmail: 'SmsAndEmail'
};

export const LaunchStates = {
  Inactive: 'Inactive',
  Active: 'Active',
};

export const AccessTypes = {
  Private: 'Private',
  Public: 'Public',
};

export const StrategySides = {
  Buy: 'Buy',
  Sell: 'Sell',
};
